module.exports = "/_next/static/images/fa52768380021652adf89b36524b07da-look-earnings.png";